import { FC } from "react";
import { FactItem } from "./FactItem";

const Facts: FC = () => {
    return (
        <div className="container-fluid sora my-5 px-5 container-vertical-padding">
            <div className="text-center">
                <h1 className="fw-bold"><span className="text-orange-1 arch-underline">Fakta</span> Penggunaan CRM</h1>
            </div>
            <div className="row mt-5 pt-5 gap-4 gap-md-0">
                <div className="col-12 col-md-4">
                    <FactItem title="300%" description="Menaikkan tingkat konversi penjualan produk" />
                </div>
                <div className="col-12 col-md-4">
                    <FactItem title="215%" description="Return on investment (ROI) diperoleh dalam waktu 3 tahun" />
                </div>
                <div className="col-12 col-md-4">
                    <FactItem title="42%" description="Akurasi sales forecasting meningkat akibat CRM" />
                </div>
            </div>
        </div>
    )
}

export { Facts }